import { render, staticRenderFns } from "./DamTxForm.vue?vue&type=template&id=834b532e&"
import script from "./DamTxForm.vue?vue&type=script&lang=js&"
export * from "./DamTxForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports